import React from 'react';
import { characters } from './data';
import styles from './CharacterContainer.module.scss';

interface IProps {
    groupID: string
}

export default function CharacterContainer(props: IProps) {

    return (
        <>
            {characters.map((item, key) => {
                if (props.groupID === item.key) {
                    return (
                        <div className={styles[`characters${item.key}`]}>
                            {item.names.map((name, key) => {
                                return (
                                    <img src={name} alt="characterimg" className={styles[`image${key}`]} />
                                )
                            })}
                        </div>
                    )
                }
            })}
        </>
    )
}